
import Common from "./result-new";
import { Component, Prop, Emit } from "vue-property-decorator";
@Component({
  components: {}
})
export default class ResultNewNew extends Common {}
